import { render, staticRenderFns } from "./PerfectMindForm.vue?vue&type=template&id=a4e236fe"
import script from "./PerfectMindForm.vue?vue&type=script&lang=js"
export * from "./PerfectMindForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports